import { StrictMode, Suspense, startTransition } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'
import { getRouter } from './router'
import { Loading } from './components'

if (import.meta.env.MODE === 'wx-webview') {
  void import('./configs/wx-webview/wx-webview.css')
}

startTransition(() => {
  const router = getRouter()
  const root = document.getElementById('root')
  if (!root) throw new Error('Root element not found')

  createRoot(root).render(
    <StrictMode>
      <Suspense fallback={<Loading />}>
        <RouterProvider router={router} />
      </Suspense>
    </StrictMode>,
  )
})
